import { Button as DSButton } from '@iziwork/design-system';
import styled from 'styled-components';

export const Button = styled(DSButton)`
  padding: 0.75rem 1rem;
  border-radius: 1.5rem;
  z-index: 0;
`;
